export const qualificationDocumentTypes = {
  ComplianceReport: {
    name: 'ComplianceReport',
    label: 'Compliance Report',
    prefill: 'Compliance Report'
  },
  CpdHistory: {
    name: 'CpdHistory',
    label: 'CPD History',
    prefill: 'CPD History'
  },
  FaseaExamResults: {
    name: 'FaseaExamResults',
    label: 'FASEA Exam Results',
    prefill: 'FASEA Exam Results'
  },
  PoliceCheck: {
    name: 'PoliceCheck',
    label: 'Police Check',
    prefill: 'Police Check'
  },
  QualificationCertificate: {
    name: 'QualificationCertificate',
    label: 'Qualification Certificate',
    prefill: 'Qualification Certificate'
  },
  QualificationTranscript: {
    name: 'QualificationTranscript',
    label: 'Qualification Transcript/Statement Of Attainment (Unit Listing)',
    prefill: 'Qualification Transcript/Statement Of Attainment (Unit Listing)'
  },
  Resume: {
    name: 'Resume',
    label: 'Resume',
    prefill: 'Resume'
  },
  TpbRenewal: {
    name: 'TpbRenewal',
    label: 'TPB Renewal/Annual Declaration',
    prefill: 'TPB Renewal/Annual Declaration'
  },
  Other: {
    name: 'Other',
    label: 'Other (please specify)',
    prefill: ''
  }
}


// WEBPACK FOOTER //
// ./src/constants/qualification.js